import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("stratedge-admin-token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy-950 px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-lg bg-white p-10 shadow-2xl">
        <Logo />
        <h1 className="mt-8 font-display text-3xl font-semibold text-navy">Admin Dashboard</h1>
        <p className="mt-1 text-sm text-slate-500">Sign in to manage Stratedge UK</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="field-label">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="field-input" data-testid="admin-email-input" autoComplete="username" />
          </div>
          <div>
            <label className="field-label">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="field-input" data-testid="admin-password-input" autoComplete="current-password" />
          </div>
          {error && <p className="rounded-md bg-red-50 p-3 text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit-button"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-navy py-3.5 text-sm font-bold text-white transition-colors hover:bg-navy-800 disabled:opacity-60">
            <Lock className="h-4 w-4" /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
